import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

const HourPicker = ({ onChange, onFocus, value }) => {

    const times = useRef([...new Array(12)].map((_, index) => `${index + 1}:00`));

    const [hour, setHour] = useState(null);
    const [timeOfDay, setTimeOfDay] = useState('am');

    const onHourChange = evt => {

        // prepare selected target using list event
        let index = Utils.attributeForKey.select(evt, 'id');
        let target = times.current[index];
        setHour(target);

        // format result as a 24-hour value and notify subscribers of data change
        let result = moment(`${target} ${timeOfDay}`, 'H a').format('H');
        if(typeof(onChange) === 'function') {
            onChange(result);
        }
    }

    const onTimeOfDayChange = evt => {

        // prepare selected target using list event
        let text = Utils.attributeForKey.select(evt, 'id');
        setTimeOfDay(text);

        // format result as a 24-hour value and notify subscribers of data change
        let result = moment(`${hour} ${text}`, 'H a').format('H');
        if(typeof(onChange) === 'function') {
            onChange(result);
        }
    }

    const onValueChange = () => {

        // prepare target hour
        let target = moment(value, 'H');

        // update local state with time and time of day selectionselection
        setHour(target.format('h'));
        setTimeOfDay(target.format('a'));
    }

    useEffect(() => {
        if(value !== null && value !== undefined) {
            onValueChange();
        }
    }, [value]);

    return (
        <div
        className={'row p-0 m-0'}
        style={{
            width: '100%'
        }}>
            <div className={'col-6 py-0 pl-0 pr-1'}>
                <select
                className={`custom-select ${window.theme}`}
                onChange={onHourChange}
                onFocus={onFocus}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px',
                    color: hour ? Appearance.colors.text() : Appearance.colors.subText(),
                    marginRight: 8
                }}
                value={hour !== null ? `${hour}:00` : 'Select a time'}>
                    <option disabled={true}>{'Select a time'}</option>
                    {times.current.map((time, index) => {
                        return <option key={index} id={index}>{time}</option>
                    })}
                </select>
            </div>
            <div className={'col-6 py-0 pl-1 pr-0'}>
                <select
                className={`custom-select ${window.theme}`}
                onChange={onTimeOfDayChange}
                onFocus={onFocus}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px',
                    marginRight: 8
                }}
                value={timeOfDay?.toUpperCase() || 'AM'}>
                    {['am','pm'].map((text, index) => {
                        return <option key={index} id={text}>{text.toUpperCase()}</option>
                    })}
                </select>
            </div>
        </div>
    )
}
export default HourPicker;
